import { render, staticRenderFns } from "./DpoPhoneNumberDisclaimer.vue?vue&type=template&id=f15e75a8&scoped=true"
import script from "./DpoPhoneNumberDisclaimer.vue?vue&type=script&lang=js"
export * from "./DpoPhoneNumberDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./DpoPhoneNumberDisclaimer.vue?vue&type=style&index=0&id=f15e75a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e75a8",
  null
  
)

export default component.exports